import React from "react";
import { Box, Button, Alert, Typography, CircularProgress } from "@mui/material";
import BaseModal from "./BaseModal";
import FormField from "../forms/FormField";
import BaseDrawer from "./mobile/BaseDrawer";
import ShopifyResetPassword from "../../utils/ShopifyResetPassword";

const ResetPasswordModal = ({ onClose, isMobile = false }) => {
  const Modal = isMobile ? BaseDrawer : BaseModal;

  const email = React.useRef("");
  const [message, setMessage] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const handleChange = (event) => {
    email.current = event.target.value;
  };

  const handleLoading = () => {
    setLoading((prevState) => !prevState);
  };

  const handleSubmit = async () => {
    handleLoading();
    try {
      const res = await ShopifyResetPassword(email.current);

      if (res?.errors?.length) {
        setMessage({ type: "error", message: res.errors[0].message });
      } else if (res?.data?.customerRecover?.customerUserErrors?.length) {
        setMessage({
          type: "error",
          message: res.data.customerRecover.customerUserErrors[0].message,
        });
      } else {
        setMessage({ type: "success", message: "We've already sent you an email." });
      }
    } catch (e) {
      setMessage({ type: "error", message: e.message });
    } finally {
      handleLoading();
    }
  };

  return (
    <Modal headline="Reset your password" onClose={onClose}>
      {message && (
        <Alert severity={message.type} sx={{ marginBottom: "20px" }}>
          {message.message}
        </Alert>
      )}
      {message?.type !== "success" && (
        <Typography
          sx={{ textAlign: "center", marginBottom: "10px", fontSize: "18px" }}
          align="center"
        >
          We will send you an email to reset your password.
        </Typography>
      )}
      <FormField label="Email" handleChange={handleChange} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "15px",
        }}
      >
        <Button
          disabled={loading}
          variant="contained"
          sx={{
            width: "100%",
            maxWidth: "280px",
            gap: "5px",
          }}
          onClick={handleSubmit}
        >
          Submit {loading && <CircularProgress size={20} color="inherit" />}
        </Button>
      </Box>
    </Modal>
  );
};

export default ResetPasswordModal;
